import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminInvoiceService {
  private url = environment.api + "api/admin/invoices";
  
  constructor(
    private http: HttpClient,
  ) { }

  getFiscalDocumentCounter(startDate: string, endDate: string) {
		return this.http.get(this.url + "/dates/" + startDate + "/" + endDate);
	}

}
